//  IframeBlocker

var CheckCookies = {
	getCookie: function (cname) {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	}
};

var IframeBlocker = {

	selector: '[data-iframe]',
	selectorOverlay: '.iframe-blocker__overlay',
	selectorButton: '.iframe-blocker__button',
	blockerImage: '.iframe-blocker__image',
	videoPlayer: '[data-video]',
	iframeId: '[data-iframe-id]',
	windowSize: window.innerWidth,
	duration: 250,

	init: function () {
		if (!$(this.selector).length) return;
		this.setDefaultState();
	},

	setDefaultState: function () {

		var hasConsentAnalytics = CheckCookies.getCookie('boeconsent');
		if (hasConsentAnalytics === "analytics") {
			$(IframeBlocker.selector).each(function (i) {
				var $thisIframe = $(this);
				var iframeType = $thisIframe.attr('data-iframe');
				var iframeOverlay = $thisIframe.find(IframeBlocker.selectorOverlay);
				var iframeImage = $thisIframe.find(IframeBlocker.blockerImage);

				if (iframeType === "vimeo") {
					var iframeVideo = $thisIframe.find(IframeBlocker.videoPlayer),
						videoID = iframeVideo.attr('data-video'),
						iframeTitle = iframeVideo.attr('data-iframe-title');

					IframeBlocker.crateIframe(videoID, iframeTitle);
					IframeBlocker.removeBlocker(iframeOverlay, iframeImage);

				} else {
					IframeBlocker.buildTableau();
				}

			});
		} else {
			IframeBlocker.bindClickEvent();
		}
	},

	bindClickEvent: function () {

		$(IframeBlocker.selectorButton).on('click', function (e) {

			// prevent default click behavior
			e.preventDefault();
			// stopPropagation to prevent the button click from bubbling up the DOM
			e.stopPropagation();

			// get attribute from button clicked
			var $thisButton = $(this);
			var iframeOverlay = $thisButton.parents(IframeBlocker.selectorOverlay);

			var thisIframe = $thisButton.parents(IframeBlocker.selector);
			var iframeType = thisIframe.attr('data-iframe');

			if (iframeType === "vimeo") {
				var iframeImage = thisIframe.find(IframeBlocker.blockerImage);
				var videoID = $thisButton.attr('data-video');
				var iframeTitle = $thisButton.attr('data-iframe-title');
				IframeBlocker.crateIframe(videoID, iframeTitle);
				IframeBlocker.removeBlocker(iframeOverlay, iframeImage);
			} else {
				IframeBlocker.buildTableau();
			}

		});

	},

	crateIframe: function (videoID, iframeTitle) {
		var tag = document.createElement('iframe');
		tag.src = "https://player.vimeo.com/video/" + videoID;
		tag.frameBorder = 0;
		tag.setAttribute('webkitallowfullscreen', '');
		tag.setAttribute('mozallowfullscreen', '');
		tag.setAttribute('allowfullscreen', '');
		tag.setAttribute('title', iframeTitle);

		var el = "#" + videoID;
		$(el).prepend(tag);

	},

	buildTableau: function () {

		$(IframeBlocker.selector).each(function (i) {
			var $thisIframe = $(this),
				iframeType = $thisIframe.attr('data-iframe'),
				tableauPlaceholder = $thisIframe.find('.tableauPlaceholder'),
				tableauObj = tableauPlaceholder.find('object'),
				iframeWidth = tableauPlaceholder.attr('data-iframe-width'),
				iframeHeight = tableauPlaceholder.attr('data-iframe-height'),
				iframeHeightMobile = tableauPlaceholder.attr('data-iframe-height-mobile'),

				iframeOverlay = $thisIframe.find(IframeBlocker.selectorOverlay),
				iframeImage = tableauPlaceholder.find(IframeBlocker.blockerImage);

			if (IframeBlocker.windowSize > 500) {
				tableauObj.css('width', iframeWidth);
				tableauObj.css('height', iframeHeight);
			} else {
				tableauObj.css('width', '100%');
				tableauObj.css('height', iframeHeightMobile);
			}

			var scriptElement = document.createElement('script');
			scriptElement.src = 'https://public.tableau.com/javascripts/api/viz_v1.js';
			$(tableauPlaceholder).append(scriptElement, tableauObj);

			if (iframeType === "tableau") {
				IframeBlocker.removeBlocker(iframeOverlay, iframeImage);
			}
		});

	},

	removeBlocker: function (iframeOverlay, iframeImage) {
		iframeOverlay.css('display', 'none');
		iframeImage.css('display', 'none');
	}
};


$(document).ready(function () {
	IframeBlocker.init();
});